module.exports = __webpack_public_path__ + "img/ic_preview@2x.9a95235e.png";